export const MOBILE_DM_PANEL_EVENT = 'realmtracker:mobile-dm-panel';
export const isMobileDmLayout = () => typeof window !== 'undefined' && Boolean(window.matchMedia?.('(max-width: 768px)').matches);
export const announceMobileDmPanel = (panel, expanded) => {
  if (isMobileDmLayout()) window.dispatchEvent(new CustomEvent(MOBILE_DM_PANEL_EVENT, { detail: { panel, expanded } }));
};
